import {
  AnesthesiaSystemEnum,
  BloodPressureMonitoringEnum,
  CatheterLocationEnum,
  QualityOfSedationEnum
} from "requests";

export const CATHETER_SIZE_OPTIONS = [26, 24, 22, 20, 18, 16, 14].map(
  value => ({
    value,
    label: `${value} Ga.`
  })
);

export const CATHETER_LOCATION_OPTIONS = [
  {
    value: CatheterLocationEnum.Intraosseous,
    label: "Intraosseous"
  },
  {
    value: CatheterLocationEnum.RightCephalic,
    label: "Right cephalic"
  },
  {
    value: CatheterLocationEnum.LeftCephalic,
    label: "Left cephalic"
  },
  {
    value: CatheterLocationEnum.RightLateralSaphenous,
    label: "Right lateral saphenous"
  },
  {
    value: CatheterLocationEnum.RightMedialSaphenous,
    label: "Right medial saphenous"
  },
  {
    value: CatheterLocationEnum.LeftLateralSaphenous,
    label: "Left lateral saphenous"
  },
  {
    value: CatheterLocationEnum.LeftMedialSaphenous,
    label: "Left medial saphenous"
  },
  {
    value: CatheterLocationEnum.RightJugular,
    label: "Right jugular"
  },
  {
    value: CatheterLocationEnum.LeftJugular,
    label: "Left jugular"
  },
  {
    value: CatheterLocationEnum.RightPeripheralAuricularVein,
    label: "Right peripheral auricular vein"
  },
  {
    value: CatheterLocationEnum.LeftPeripheralAuricularVein,
    label: "Left peripheral auricular vein"
  },
  {
    value: CatheterLocationEnum.RightBasilicVein,
    label: "Right basilic vein"
  },
  {
    value: CatheterLocationEnum.LeftBasilicVein,
    label: "Left basilic vein"
  },
  {
    value: CatheterLocationEnum.RightMedialTarsometatarsalVein,
    label: "Right medial tarsometatarsal vein"
  },
  {
    value: CatheterLocationEnum.LeftMedialTarsometatarsalVein,
    label: "Left medial tarsometatarsal vein"
  },
  {
    value: CatheterLocationEnum.IntraosseousFemoral,
    label: "Intraosseous (femoral)"
  },
  {
    value: CatheterLocationEnum.IntraosseousTibial,
    label: "Intraosseous (tibial)"
  },
  {
    value: CatheterLocationEnum.IntraosseousUlnar,
    label: "Intraosseous (ulnar)"
  },
  {
    value: CatheterLocationEnum.IntraosseousPlastroCarapacialBridge,
    label: "Intraosseous (plastro-carapacial bridge)"
  },
  {
    value: CatheterLocationEnum.VentralTailVein,
    label: "Ventral tail vein"
  },
  {
    value: CatheterLocationEnum.Intracardiac,
    label: "Intracardiac"
  },
  {
    value: CatheterLocationEnum.PalatineVein,
    label: "Palatine vein"
  }
];

export const FLUID_TYPE_OPTIONS = [
  "LRS",
  "0.9% NaCl",
  "Normosol-R",
  "Plasmalyte"
].map(value => ({ value, label: value }));

export const BLOOD_PRESSURE_MONITORING = [
  {
    value: BloodPressureMonitoringEnum.NonInvasive,
    label: "Non-invasive"
  },
  {
    value: BloodPressureMonitoringEnum.Invasive,
    label: "Invasive"
  }
];

export const QUALITY_OF_SEDATION_OPTIONS = [
  { value: QualityOfSedationEnum.Mild, label: "Mild" },
  { value: QualityOfSedationEnum.Moderate, label: "Moderate" },
  { value: QualityOfSedationEnum.Profound, label: "Profound" }
];

export const ANESTHESIA_SYSTEM_OPTIONS = [
  {
    value: AnesthesiaSystemEnum.Rebreathing,
    label: "Rebreathing"
  },
  {
    value: AnesthesiaSystemEnum.NonRebreathing,
    label: "Non-rebreathing"
  }
];

export const INTUBATED_OPTIONS = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" }
];

export const FLUID_RATE_OPTIONS = [
  { value: "3", label: "3 mL/kg/hour" },
  { value: "5", label: "5 mL/kg/hour" },
  { value: "10", label: "10 mL/kg/hour" }
];
